import InfoIcon from "@mui/icons-material/Info";
import { Box, Typography } from "@mui/material";
import ReadOnlyTextField from "components/common/ReadOnlyTextField";
import { colorTokens } from "theme/colorTokens";

interface PracticeContactInfoProps {
  readonly email: string;
  readonly phoneNumber: string;
  readonly faxNumber?: string;
}

function PracticeContactInfo({
  email,
  phoneNumber,
  faxNumber,
}: PracticeContactInfoProps) {
  return (
    <Box className="space-y-4">
      <Box className="flex items-center gap-2">
        <Typography variant="h6" className="text-xl font-medium text-gray-900">
          Contact Information
        </Typography>
        <InfoIcon sx={{ color: colorTokens.gray[500], fontSize: "1.25rem" }} />
      </Box>

      <Box className="space-y-4">
        <ReadOnlyTextField label="Email Address" value={email} />
        <ReadOnlyTextField label="Primary Phone Number" value={phoneNumber} />
        <ReadOnlyTextField label="Fax Number" value={faxNumber || "-"} />
      </Box>
    </Box>
  );
}

export default PracticeContactInfo;
